/*
 * HEXA refinements that need script (numbers from the Impeccable numbered copy):
 *   08  the sticky add-to-cart button gets an accessible name
 *   31  "139.00 ₪" shows as "139 ₪", only when the agorot really are zero
 */
(function () {
  var ZERO_AGOROT = /(\d)\.00(?=\s*₪)/g;

  function wholeShekels(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.closest('script, style, textarea, input')) continue;
      if (node.nodeValue.indexOf('.00') === -1) continue;
      var next = node.nodeValue.replace(ZERO_AGOROT, '$1');
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function run() {
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'הוספה לסל');
    });

    wholeShekels(document.body);

    /* The cart drawer re-renders its contents after every change. */
    var drawer = document.getElementById('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          wholeShekels(drawer);
        });
      }).observe(drawer, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
